type LinkIcon = 'Calendar' | 'EAppointment' | 'VideoAppointment' | 'Prescription' | 'Contact' | 'Other'
export interface Link {
    id: string;
    title: string;
    url: string;
    description: string;
    createdAt: Date;
    icon: LinkIcon;
}

export function createEmptyLink(): Link {
    return {
        id: '0',
        title: '',
        url: '',
        description: '',
        createdAt: new Date(),
        icon: 'Other'
    }
}



export const linkIcons = [
    { label: 'Kalender', value: 'Calendar', iconname: 'hugeicons:calendar-01' },
    { label: 'E-avtale', value: 'EAppointment', iconname: 'hugeicons:doctor-01' },
    { label: 'Video-avtale', value: 'VideoAppointment', iconname: 'hugeicons:computer-video-call' },
    { label: 'Resept', value: 'Prescription', iconname: 'hugeicons:give-pill' },
    { label: 'Kontakt', value: 'Contact', iconname: 'hugeicons:message-01' },
];